import React from 'react';
import { NumberInput, BooleanInput, required, minValue, maxValue } from 'react-admin';
import { Box, Grid, Typography } from '@mui/material';
import { useTranslate } from '../common/language';

export const ServicePricingInputs = () => {
  const translate = useTranslate();
  return <>
    {['tickets', 'subscriptions', 'donations'].map(kind => {
      const prefix = kind === 'donations' ? 'donations' : 'ara_' + kind;
      return <Box key={kind} sx={{ border: '1px solid #ddd', borderRadius: 1, p: 2, my: 2 }}>
        <Typography variant="h6" gutterBottom>{translate('settings.service_block_' + kind)}</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={kind === 'donations' ? 6 : 4}>
            <NumberInput fullWidth source={prefix + '_commission'} label={translate('settings.' + prefix + '_commission')} validate={[required(), minValue(0)]} />
          </Grid>
          <Grid item xs={12} sm={kind === 'donations' ? 6 : 4}>
            <NumberInput fullWidth source={prefix + '_tax_percent'} label={translate('settings.' + prefix + '_tax_percent')} validate={[required(), minValue(0), maxValue(100)]} />
          </Grid>
          {kind !== 'donations' && <>
            <Grid item xs={12} sm={4}>
              <NumberInput fullWidth source={prefix + '_minimum_fee'} label={translate('settings.' + prefix + '_minimum_fee')} step={0.01} validate={[required(), minValue(0)]} />
            </Grid>
            {kind === 'subscriptions' && <Grid item xs={12}>
              <BooleanInput source="ara_tickets_subscription_fee_per_ticket" label={translate('settings.ara_tickets_subscription_fee_per_ticket')} />
            </Grid>}
            <Grid item xs={12}>
              <BooleanInput source={kind + '_management_fees_included'} label={translate('settings.' + kind + '_management_fees_included')} />
            </Grid>
          </>}
        </Grid>
      </Box>;
    })}
  </>;
};

export const DefaultTaxInputs = () => {
  const translate = useTranslate();
  return <>
    {['tickets', 'subscriptions'].map(kind => <Box key={kind} mt={2} mb={2}>
      <Typography variant="h6" gutterBottom>{translate('settings.service_block_' + kind)}</Typography>
      <NumberInput fullWidth source={kind + '_vat_percent'} label={translate('settings.' + kind + '_vat_percent_default')} step={0.01} validate={[required(), minValue(0), maxValue(100)]} />
      <BooleanInput source={kind + '_vat_included'} label={translate('settings.' + kind + '_vat_included_default')} />
    </Box>)}
  </>;
};
